import { FilePlus2, LayoutTemplate } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function CollectionCreationChoice({
  onChange,
}: {
  onChange: (mode: 'manual' | 'template') => void
}) {
  const { t } = useTranslation('documentCollections')

  return (
    <div className="grid gap-3 px-4 sm:grid-cols-2">
      <CreationChoice
        description={t('documentCollections:defineNewCollectionHint')}
        icon={<FilePlus2 className="mb-4 size-6 text-primary" />}
        title={t('documentCollections:defineNewCollection')}
        onClick={() => onChange('manual')}
      />
      <CreationChoice
        description={t('documentCollections:createFromTemplateHint')}
        icon={<LayoutTemplate className="mb-4 size-6 text-primary" />}
        title={t('documentCollections:createFromTemplate')}
        onClick={() => onChange('template')}
      />
    </div>
  )
}

function CreationChoice({
  description,
  icon,
  onClick,
  title,
}: {
  description: string
  icon: React.ReactNode
  onClick: () => void
  title: string
}) {
  return (
    <button
      type="button"
      className="rounded-xl border p-5 text-left transition-colors hover:border-primary hover:bg-accent"
      onClick={onClick}
    >
      {icon}
      <span className="block font-semibold">{title}</span>
      <span className="mt-1 block text-sm text-muted-foreground">
        {description}
      </span>
    </button>
  )
}
